import { getHostnameByCountry } from '../get-hostname-by-country';

export const getOriginByCountry = (country: string): string => {
  const url = new URL(window.location.origin);

  url.hostname = getHostnameByCountry(url.hostname, country);

  return url.origin;
};
